module.exports = ":host .description-text-styles {\n  font-weight: 400 !important;\n  font-size: 16px;\n  line-height: 25px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/setting-section-description/setting-section-description.scss
// module id = ./web/modern/components/settings/common/setting-section-description/setting-section-description.scss
// module chunks = 0